import { TrendingUp, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { FLIPS } from "../../data/content";

export const Flips = () => (
  <section id="flips" data-testid="flips-section" className="bg-ink text-paper">
    <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-40">
      <Reveal className="max-w-3xl">
        <p className="overline text-terracotta flex items-center gap-2">
          <TrendingUp size={14} /> (05.85) Real Estate
        </p>
        <h2 className="mt-6 font-serif text-5xl md:text-7xl tracking-tight leading-[0.95]">
          Highest-profit
          <br />
          flips to date.
        </h2>
        <p className="mt-6 text-base md:text-lg text-white/60 leading-relaxed max-w-2xl">
          A selection of my top renovation-and-resale projects, where design instinct meets
          construction know-how and real market value.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        {FLIPS.map((f, i) => (
          <Reveal key={f.key} delay={i * 0.1}>
            <div
              data-testid={`flip-${f.key}`}
              className="group h-full overflow-hidden rounded-2xl border border-white/12 bg-white/[0.03] hover:-translate-y-1.5 hover:border-white/30 transition-[transform,border-color] duration-500"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={f.src}
                  alt={f.address}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute right-4 top-4 rounded-full bg-terracotta text-paper px-3 py-1.5 text-[0.65rem] uppercase tracking-[0.16em]">
                  Sold
                </span>
              </div>
              <div className="p-6">
                <p className="flex items-center gap-2 text-sm text-white/55">
                  <MapPin size={15} className="text-sage" /> {f.address}
                </p>
                <p className="mt-2 font-serif text-4xl md:text-5xl tracking-tight text-paper">{f.price}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
